import { useHomeTabs } from 'hooks/home/tabs'

import { AllUsersScope } from './scopes/all_users_scope'
import { SingleUserScope } from './scopes/single_user_scope'
import { TeamsScope } from './scopes/teams_scope'
import { UserGroupScope } from './scopes/user_groups_scope'

export const Filters = ({
  selectedHostIds, setSelectedHostIds,
  selectedOwnerIds, setSelectedOwnerIds,
  selectedUserIds, setSelectedUserIds,
  selectedPermission, setSelectedPermission,
  scopeOverride,
}) => {
  const { getTabScopeV1 } = useHomeTabs()
  const { type: eventTypesScope } = getTabScopeV1()
  const effectiveScope = scopeOverride || eventTypesScope
  const isSingleUserScope = effectiveScope === 'my_calendly' || effectiveScope === 'user_single'
  const isUserGroupScope = effectiveScope === 'user_group'
  const isTeamsPage = effectiveScope === 'page' || effectiveScope === 'page_single'

  if (isTeamsPage) {
    return (
      <TeamsScope
        selectedHostIds={selectedHostIds}
        setSelectedHostIds={setSelectedHostIds}
      />
    )
  }

  if (isUserGroupScope) {
    return (
      <UserGroupScope
        selectedOwnerIds={selectedOwnerIds}
        setSelectedOwnerIds={setSelectedOwnerIds}
        selectedUserIds={selectedUserIds}
        setSelectedUserIds={setSelectedUserIds}
      />
    )
  }

  if (isSingleUserScope) {
    return (
      <SingleUserScope
        selectedHostIds={selectedHostIds}
        setSelectedHostIds={setSelectedHostIds}
        selectedOwnerIds={selectedOwnerIds}
        setSelectedOwnerIds={setSelectedOwnerIds}
        selectedPermission={selectedPermission}
        setSelectedPermission={setSelectedPermission}
      />
    )
  }

  return (
    <AllUsersScope
      selectedHostIds={selectedHostIds}
      setSelectedHostIds={setSelectedHostIds}
      selectedOwnerIds={selectedOwnerIds}
      setSelectedOwnerIds={setSelectedOwnerIds}
      selectedUserIds={selectedUserIds}
      setSelectedUserIds={setSelectedUserIds}
      selectedPermission={selectedPermission}
      setSelectedPermission={setSelectedPermission}
    />
  )
}
